import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';
import axios from 'axios';
import {API_URL} from '../../../constants';
import Error from '../../Error/error';
import cookie from 'react-cookies';
import {approveRole} from '../../../functions';
import {updateValueInJson, showCreateGlosario, showEditGlosario, cancelFormularioGlosario, validateUrl, getRoles} from '../../../functions';
import $ from 'jquery';
import { toast } from 'react-toastify';

const defaultseodata= {
    // miniaturaImagenSEO:     null,
    glosarioCodigo:         0,
    glosarioDescripcionSEO: "",
    glosarioEnlaceSEO:      "",
    glosarioImagenSEO:      "",

    glosarioLetra:          "",

    glosarioMostrarBuscadoresSEO:   false,
    glosarioScriptSEO:      "",
    glosarioSeguirBuscadoresSEO:    false,
    glosarioTituloSEO:      "",
    
}

export default class Glosario extends Component {


    constructor(props){
        super(props);
		this.handleLoad = this.handleLoad.bind(this);
        
        this.state = {
            resource: [],
            resourceForm: {
                glos_Letra:"",
                glos_Titulo:"",
                glos_Descripcion:"",
                glos_Orden:0,
                glos_Activo:true
            },
            resourceFormEdit: {
                glos_Letra:"",
                glos_Titulo:"",
                glos_Descripcion:"",
                glos_Orden:0,
                glos_Activo:true
            },
            letter:{
                seo: defaultseodata
            },
            Validacion: {
                glos_Letra: {
                    Error: false,
                },
                glos_Titulo: {
                    Error: false,
                },
                glos_Descripcion: {
                    Error: false,
                },
                glos_Orden: {
                    Error: false,
                },
                glos_Activo: {
                    Error: false,
                }
            },
            tituloLongitud:0,
            response: [],
            error: [],
            security: cookie.load('user'),
            roles: [],
            filters:{
                texto:''
            },
            pagina: 1,
            offRows:0,
            letraSeleccionada:'',
            letraFormulario:'',
            menuGeneral:[],
            agrupador:""
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeForm = this.handleInputChangeForm.bind(this);
        this.handleInputChangeFormEdit = this.handleInputChangeFormEdit.bind(this);
        this.changeSeoValue = this.changeSeoValue.bind(this);
        this.changeSeoCheck = this.changeSeoCheck.bind(this);
        this.updateSeoInLetter = this.updateSeoInLetter.bind(this);
    }

    editar = (entity, e) => {
        e.preventDefault();
        showEditGlosario(e);
        this.setState({resourceFormEdit:entity});
    }

    callFunctionButtonActualizar = (e) => {

        e.preventDefault();

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceFormEdit.glos_Titulo == '') {
            newState.Validacion.glos_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceFormEdit.glos_Descripcion == '') {
            newState.Validacion.glos_Descripcion = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        var textoFilter = newState.resourceFormEdit.glos_Titulo;

        let letra_seleccionada = (textoFilter.trim()).charAt(0);

        const url = `${API_URL}GlosarioUX/`;
        var dataForm = this.state.resourceFormEdit;
        dataForm.glos_Letra = letra_seleccionada;
        dataForm = updateValueInJson(dataForm,'glos_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url,
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {

            if (data.data.isSucess)
            {

                let stateResponse = this.state;

                stateResponse.added = true;
                this.setState(stateResponse);

                setTimeout(() => {
                    this.setState({added:false});
                }, 3000);

                this.buscarGlosario("A");

            } else
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => {
                    this.setState({hasErrorProceso:false});
                }, 3000);
            }

            cancelFormularioGlosario();

        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });
    }

    callFunctionButtonCreate = (event) => {

        event.preventDefault();

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceForm.glos_Titulo == '') {
            newState.Validacion.glos_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceForm.glos_Descripcion == '') {
            newState.Validacion.glos_Descripcion = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        var textoFilter = newState.resourceForm.glos_Titulo;

        let letra_seleccionada = (textoFilter.trim()).charAt(0);

        const url = `${API_URL}GlosarioUX/`;
        var dataForm = this.state.resourceForm;
        dataForm.glos_Letra = letra_seleccionada;
        dataForm = updateValueInJson(dataForm,'glos_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url,
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {

            if (data.data.isSucess)
            {

                let stateResponse = this.state;

                stateResponse.added = true;
                stateResponse.resourceForm.glos_Titulo = '';
                stateResponse.resourceForm.glos_Descripcion = '';
                this.setState(stateResponse);

                setTimeout(() => {
                    this.setState({added:false});
                }, 3000);

                this.buscarGlosario("A");

            } else
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => {
                    this.setState({hasErrorProceso:false});
                }, 3000);
            }

            cancelFormularioGlosario();

        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });
    }

    handleClickCancel(e){
        e.preventDefault();
        cancelFormularioGlosario(e);
    }

    returnAdministradores(e) {

        e.preventDefault();

        const {history: {push}} = this.props;
        push('/administradores');
     }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let filters = this.state.filters;
        filters[target.name] = value;

        this.setState({filters: filters});
    }

    handleInputChangeForm(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceForm;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,
        }

        if(target.name == 'glos_Titulo'){
            tituloLongitud = value.length;
        }
        this.setState({
            resourceForm: copyResource,
            tituloLongitud: tituloLongitud,
            Validacion: validaciones
        });
    }

    handleInputChangeFormEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceFormEdit;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,
        }

        if(target.name == 'glos_Titulo'){
            tituloLongitud = value.length;
        }
        this.setState({
            resourceFormEdit: copyResource,
            tituloLongitud: tituloLongitud,
            Validacion: validaciones
        });
    }

    buscarGlosario = (letra = 'A') => {

        const url = `${API_URL}GlosarioUX/1/${letra}`;
        axios.get(url).then(response => response.data)
        .then((data) => {

            let offRows = 0;
            if(data.result.listaPalabra.length > 0){
                offRows = data.result.listaPalabra[0].offset * 1;
            }

            const seoglosariopalabra = data.result.informacionSEO;

            this.setState({
                filters:{
                    texto:''
                },
                letraSeleccionada: letra,
                resource: data.result.listaPalabra,
                response: data,
                error: data.Error,
                pagina: 1,
                offRows:offRows,
                letter: {
                    ...this.state.letter, 
                    seo: seoglosariopalabra ? seoglosariopalabra : defaultseodata
                }
            });
			this.ShowPaginationFive(0);
           // document.getElementById('content-wrapper').removeAttribute("hidden");
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.callFunctionButton(e);
        }
    }

    eliminarRegistro = async(entity, event) => {
        event.preventDefault();
        const url = `${API_URL}GlosarioUX/Eliminar`;

        let dataToSave=updateValueInJson(entity, 'glos_UsuarioEliminacion', this.state.security.nUsuCodigo);
        const formData = JSON.stringify(dataToSave);

        await axios.put(
            url,
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {
                    if (data.data.isSucess)
                    {
                        setTimeout(() => {
                            this.executePagination(this.state.pagina);
                        }, 1000);
                    } else
                    {
                        this.setState({loading:false});
                        console.log('No se pudo procesar la solicitud \r');
                    }
                }
            ).catch((error)=> {
                console.log('Error no controlado.');
                this.setState({loading:false});
            });
    }

    callFunctionButton = (event) => {

        event.preventDefault();

        var textoFilter = document.getElementById('texto_filter').value;

        let letra_seleccionada = (textoFilter.trim()).charAt(0);

        if(letra_seleccionada == ''){
            this.buscarGlosario('A');
            return;
        }

        this.setState({
            filters:{
                texto: textoFilter
            }, 
            letraSeleccionada:letra_seleccionada
        });

        const url = (textoFilter != '') ? `${API_URL}GlosarioUX/1/${letra_seleccionada}/${textoFilter}` : `${API_URL}ProgramaCapacitacionUX/1/${letra_seleccionada}`;

        axios.get(url).then(response => response.data)
        .then((data) => {

            let offRows = 0;
            if(data.result.listaPalabra.length > 0){
                offRows = data.result.listaPalabra[0].offset * 1;
            }

            this.setState({ 
                resource: data.result.listaPalabra, 
                response: data, error: 
                data.Error, 
                offRows:offRows
            });
            
			this.ShowPaginationFive(0);
            document.getElementById('content-wrapper').removeAttribute("hidden");
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

	executePaginationPrev(page, e)
	{
		if(!$(".divPaginador a.active").prev().hasClass("btnPrevPaginador"))
		{			
			this.executePagination(parseInt($(".divPaginador a.active").prop("id"))-1, e);
		}
	}
	
	executePaginationNext(page, e)
	{
		if(!$(".divPaginador a.active").next().hasClass("btnNextPaginador"))
		{
			this.executePagination(parseInt($(".divPaginador a.active").prop("id"))+1, e);
		}
	}
	
    executePagination(page, e){

        if(e != undefined){
            e.preventDefault();
        }

        var roles = this.state.security.cRolesxUsuario.filter(option=> { return option.cRoles.nTipSistema==="0"; });
        var flag = approveRole(roles);
        //var estados= (flag?('A,R'):('B'));
        var usuario = (flag?(0):(this.state.security.nUsuCodigo));

        let textoFilter = this.state.filters.texto;
        let letra_seleccionada = this.state.letraSeleccionada;

        const url = (textoFilter != '') ? `${API_URL}GlosarioUX/${page}/${letra_seleccionada}/${textoFilter}` : `${API_URL}GlosarioUX/${page}/${letra_seleccionada}`;
        var entity = this.state.resource.length>0?this.state.resource[0]:null;

        for(let index=0; index < entity.totalPages+2; index++)
        {
            if($("#"+index).is("*"))
			{
				document.getElementById(index).classList.remove("active");
			}
        }

        if($("#"+page).is("*")){
			document.getElementById(page).classList.add("active");
		}

		$(".ipl-progress-indicator").fadeIn();
		$(".ipl-progress-indicator-head").css({"width": "90%"});

        axios.get(url).then(response => response.data)
        .then((data) => {
			
			$(".ipl-progress-indicator-head").css({"width": "100%"});
			setTimeout(function()
			{
				$(".ipl-progress-indicator").hide();
				$(".ipl-progress-indicator-head").css({"width": "0%"});
			}, 200);

            let offRows = 0;
            if(data.result.listaPalabra.length > 0){
                offRows = data.result.listaPalabra[0].offset;
            }

            this.setState({ 
                resource: data.result.listaPalabra, 
                response: data, 
                error: data.Error, 
                pagina: page, 
                offRows:offRows 
            });
			this.ShowPaginationFive(page-1);
        })
        .catch(error => {
        });
    }
	
	ShowPaginationFive(pagina)
	{
		$(".divPaginador a.active").removeClass("active");
		$(".divPaginador a:eq("+pagina+")").next().addClass("active");
		
		$(".divPaginador .pageItem").hide();
		
		let ItemPage = parseInt($(".divPaginador a.active").prop("id"));
		if(ItemPage < 4)
		{
			$(".divPaginador .pageItem").slice(0,5).show();
		}
		else if(ItemPage < 5)
		{
			$(".divPaginador .pageItem").slice(1,6).show();
		}
		else if(ItemPage < 6)
		{
			$(".divPaginador .pageItem").slice(2,7).show();
		}
		else if(ItemPage >= 6)
		{
			$(".divPaginador .pageItem.active").prev().prev().show();
			$(".divPaginador .pageItem.active").prev().show();
			$(".divPaginador .pageItem.active").show();
			$(".divPaginador .pageItem.active").next().show();
			$(".divPaginador .pageItem.active").next().next().show();
		}
		
		if(!$(".pageItem.active").next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().show()
		  }
		}
		if(!$(".pageItem.active").next().next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().prev().show()
		  }
		}
	}

    paginationTable()
    {
        var entity = this.state.resource.length > 0 ? this.state.resource[0] : null;

        const options = [];

        if (entity !== null){

            if(entity.totalPages == 1){
                return null;
            }

            options.push(<a className="btnPrevPaginador" id={0} key={0} onClick={(e) => this.executePaginationPrev(0, e)}></a>);

            for(let index=1; index < entity.totalPages+1; index++)
			{
                options.push(<a className="pageItem" id={index} key={index} onClick={(e) => this.executePagination(index, e)}> {index} </a>);
			}

            options.push(<a className="btnNextPaginador" id={entity.totalPages+1} key={entity.totalPages+1} onClick={(e) => this.executePaginationNext(entity.totalPages+1, e)}></a>);

        return (
			<div className="divPaginador divPaginadorGlosario" key={"pagination"} id="pagination">
                {options}
            </div>
        );
        }
    }

    loadMenus = (agrupador = "") => {

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";
        let sUrl = this.props.location.pathname;

        const url = `${API_URL}MenuUX/${rol}`;

        axios.get(url).then(response => response.data)
        .then((data) => {

          let menuTemp = [{
            sAgrupador:"Administradores",
            sOpcNombre:"Menus",
            sUrl:"/menu"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorias de Certificaciones",
            sUrl:"/categorias-certificacion"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Exporta Fácil",
            sUrl:"/categorias-exporta-facil"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Preguntas Frecuentes",
            sUrl:"/categorias-faq"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Herramientas de Análisis",
            sUrl:"/categorias-herramienta-analisis"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Puede Interesarte",
            sUrl:"/categorias-puede-interesarte"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Páginas",
            sUrl:"/paginas"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de H. de Análisis",
            sUrl:"/herramientas-analisis"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Certificaciones",
            sUrl:"/certificaciones"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Oficinas en el Mundo",
            sUrl:"/oficinas-mundo"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. También Puede Interesarte",
            sUrl:"/puede-interesarte"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Documentación para Exportar",
            sUrl:"/documento-exportacion"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Guías para el Exportador",
            sUrl:"/guia-exportador"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Categorías Potencial de Exportación",
            sUrl:"/categorias-potencial-exportador"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. Exporta Fácil",
            sUrl:"/exporta-facil"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. Productos Priorizados por Sector y Mercado",
            sUrl:"/productos-priorizado"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de H. para Pymes",
            sUrl:"/herramientas-pyme"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. H. Externas",
            sUrl:"/herramientas-externa"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Programas de Capacitación",
            sUrl:"/programas-capacitacion"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Glosarios",
            sUrl:"/glosario"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. FAQ",
            sUrl:"/faqs"
          },
          {
            sAgrupador:"Usuarios",
            sOpcNombre:"Usuarios",
            sUrl:"/usuarios"
          },
          {
            sAgrupador:"Usuarios",
            sOpcNombre:"Roles",
            sUrl:"/perfiles"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Encuestas",
            sUrl:"/reporte-encuesta"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Logs",
            sUrl:"/reporte-logs"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Suscriptor",
            sUrl:"/reporte-suscriptor-footer"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Trazabilidad",
            sUrl:"/reporte-trazabilidad"
          },
          {
            sAgrupador:"Configuradores",
            sOpcNombre:"Panel de Configuración",
            sUrl:"/configuradores"
          }]

          menuTemp.map((menu) => (
            data.result.push(menu)
          ))
      
          var menuGeneral = data.result;

          validateUrl(menuGeneral, sUrl, ""); 

          if(menuGeneral != null){
            this.setState({
                menuGeneral: menuGeneral,
                agrupador: "Administradores"
            });
          }
      })
      .catch(error => {
          console.log(error);
      });
    }

    componentDidMount(){
        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let newState = this.props.location.state;
        if(newState != undefined){  

            let sUrl = this.props.location.pathname;

            validateUrl(newState.menuGeneral, sUrl);     

            this.setState({
                menuGeneral: newState.menuGeneral,
                agrupador: newState.agrupador
            });            
        }else{
            this.loadMenus();
        }

        var roles = this.state.security.cRolesxUsuario.filter(option=> { return option.cRoles.nTipSistema==="0"; });
        var flag = approveRole(roles);
        var usuario = (flag?(0):(this.state.security.nUsuCodigo));

        this.setState({ roles : roles});
		
		let _this = this;
    }

	handleLoad(){
		setTimeout(() =>
		{
			$(".slick_l").slick({
				dots: false,
				infinite: true,
				speed: 300,
				slidesToShow: 13,
				centerMode: false,
				variableWidth: false,
			});
		},200);
	}
    
    changeSeoValue(e){
        const {value, name} = e.target;
        let seodata = this.state.letter.seo;

        seodata[name] = value;

        this.setState({
            letter: {
                ...this.state.letter,
                seo: seodata
            }
        });
    }

    changeSeoCheck(name, val){
        let seodata = this.state.letter.seo;
        seodata[name] = val;

        this.setState({
            letter: {
                ...this.state.letter,
                seo: seodata
            }
        });
    }

    updateSeoInLetter(e){
        e.preventDefault();
        let seodata = this.state.letter.seo;
        seodata.glosarioLetra = this.state.letraSeleccionada;
        const url = `${API_URL}GlosarioUX/InsertarGlosarioSEO`;
        seodata = JSON.stringify(seodata)
        axios.post(url, JSON.stringify(seodata),{
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            console.log(res.data);
            toast.success('Seo actualizado correctamente');
        }).catch((err) => {
            console.error(err);
        });
    }

    render() {

        const letras = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","Ñ","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
        
        return (
            <div>
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="" />
                        <a  href="/">
                            / Panel de configuración general
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Glosario</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                Glosario
                </div>
                <div className="divGlosario">
                    {
                        this.state.letraSeleccionada == '' ?
                            <h2>Seleccione una letra para empezar</h2>
                        : null
                    }

                    <div className="divSearchGlosario">
                        <input 
                            type="text" 
                            placeholder="Encontrar palabra..." 
                            name="texto" 
                            onChange={this.handleInputChange} 
                            value={this.state.filters.texto} 
                            id="texto_filter" 
                            onKeyDown={this._handleKeyDown}
                        />
                        <input 
                            type="submit" 
                            defaultValue="Buscar" 
                            onClick={(event) => this.callFunctionButton(event)}
                        />
                    </div>

                    <div className="divLetrasGlosarios">
                        <div className='container-letras'>
                            {letras.map((item, key) => {
                                return <div 
                                    style={{ background: this.state.letraSeleccionada === item ? '#015696' : '#B2B1B6' }}
                                    className='content-letter' 
                                    key={key} 
                                    onClick={() => this.buscarGlosario(item)}
                                >
                                    {item}
                                </div>
                            })}
                        </div>
                    </div>
                    <div id="container-listado">
                        {this.state.letraSeleccionada != '' ?
                            <div className="divWrapperGlosario1">
                                <div className='div_Modulos_glosario'>
                                    <h2>Lista de palabras</h2>
                                </div>
                                <div className="divResultadosGlosario">
                                    {this.state.resource.length > 0 ?
                                        this.state.resource.map((glosario) => (
                                            <div className="x-2 divTitleGlosario" key={"item_glosario_" + glosario.glos_Id}>
                                                <span>{glosario.glos_Titulo}</span>
                                                <div className="divBtnGlosario">
                                                <a href="#" className="btnGlosarioEditar" onClick={(e) => this.editar(glosario, e)}/>
                                                <a href className="btnGlosarioEliminar aEliminarMenu2"/>
												<div className="c_divAlertaCapa">
													<div className="divAlertaCapa">
														<div className="divAlerta">
															<h2>&iquest;Seguro de eliminar?</h2>
															<div className="divAlertaBtn">
																<a href="#" className="btnAlertaAceptar" onClick={(event) => this.eliminarRegistro(glosario, event)}>ACEPTAR</a>
																<a href="#" className="btnAlertaCancelar">CANCELAR</a>
															</div>
														</div>
													</div>
												</div>
                                                </div>
                                            </div>
                                        )) :
                                        <div>
                                            <span>NO SE ENCONTRARON RESULTADOS</span>
                                        </div>
                                    }
                                    {this.paginationTable()}
                                </div>

                                <div className="divContenedorBtn_Glosario">
                                    <a href="" className="btnAddPalabraGlosario btnActivo" id="btnCreateGlosario" onClick={(e) => showCreateGlosario(e)}>AGREGAR </a>
                                </div>
                            </div> : null
                        }
                    </div>

                    <div id="containerFormCreate" style={{display:"none"}}>
                        <div className="divWrapperGlosario2">
                            <div className='div_Modulos_glosario'>
                                <h2>Agregar palabra</h2>
                            </div>
                            <div className="divAddPalabraGlosario">
                                <div className="txtFile x-1">
                                    <input type="text" name="glos_Titulo" placeholder="Titular" value={this.state.resourceForm.glos_Titulo} maxLength={200} className={this.state.Validacion.glos_Titulo.Error ? "error" : ""} onChange={this.handleInputChangeForm}/>
                                    <span>{this.state.tituloLongitud}/200</span>
                                </div>
                                <div className="textareaResumen x-1">
                                    <textarea placeholder="Resumen" value={this.state.resourceForm.glos_Descripcion} name="glos_Descripcion" className={this.state.Validacion.glos_Descripcion.Error ? "error" : ""} onChange={this.handleInputChangeForm} maxLength={500} />
                                </div>
                            </div>
                        </div>
                        <div className="divContenedorBtn_Glosario">
                            <a href="" className="btnAddPalabraGlosario btnActivo" onClick={(event) => this.callFunctionButtonCreate(event)}>GUARDAR </a>
                            <a href="#" className="btnPrevAddPalabraGlosario" onClick={(event) => this.handleClickCancel(event)}>CANCELAR</a>
                        </div>
                    </div>

                    <div id="containerFormUpdate"  style={{display:"none"}}>
                        <div className="divWrapperGlosario2">
                            <div className='div_Modulos_glosario'>
                                <h2>Editar palabra</h2>
                            </div>
                            <div className="divAddPalabraGlosario">
                                <div className="txtFile x-1">
                                    <input type="text" name="glos_Titulo" placeholder="Titular" value={this.state.resourceFormEdit.glos_Titulo} maxLength={200} className={this.state.Validacion.glos_Titulo.Error ? "error" : ""} onChange={this.handleInputChangeFormEdit}/>
                                    <span>{this.state.tituloLongitud}/200</span>
                                </div>
                                <div className="textareaResumen x-1">
                                    <textarea placeholder="Resumen" value={this.state.resourceFormEdit.glos_Descripcion} name="glos_Descripcion" className={this.state.Validacion.glos_Descripcion.Error ? "error" : ""} onChange={this.handleInputChangeFormEdit}  maxLength={500} />
                                </div>
                            </div>
                        </div>
                        <div className="divContenedorBtn_Glosario">
                            <a href="" className="btnAddPalabraGlosario btnActivo" onClick={(event) => this.callFunctionButtonActualizar(event)}>ACTUALIZAR </a>
                            <a href="#" className="btnPrevAddPalabraGlosario" onClick={(event) => this.handleClickCancel(event)}>CANCELAR</a>
                        </div>
                    </div>

                    {/* SEO */}
                    {this.state.letraSeleccionada != '' &&
                    <div className='div_Modulos_glosario'>
                        <div className="divModulo_Seo">
                            <h2>Configuración <strong>SEO</strong></h2>
                            <div className="divWrapperModulo_Seo">
                                <div className="txtFile x-1">
                                    <input 
                                        type="text" 
                                        placeholder="SEO Título" 
                                        id='tituloSEO' 
                                        name='glosarioTituloSEO'
                                        maxLength="255" 
                                        className="data-test data-form"
                                        value={this.state.letter.seo.glosarioTituloSEO}
                                        onChange={(e) => this.changeSeoValue(e)}
                                    />
                                    <span id="longitudtituloSEO"></span>
                                </div>
                                <div className="txtFile x-1">
                                    <textarea 
                                        name='glosarioDescripcionSEO'
                                        placeholder="SEO Descripción" 
                                        id='descripcionSEO' 
                                        maxLength="255" 
                                        style={{height:"100px"}} 
                                        className="data-test data-form"
                                        value={this.state.letter.seo.glosarioDescripcionSEO}
                                        onChange={(e) => this.changeSeoValue(e)}
                                    />
                                    <span id="longituddescripcionSEO"></span>
                                </div>
                                {/* 
                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" onClick={() => this.showModalFile("divImagenSEOUpload")} />
                                    <input type="text" placeholder="SEO Imagen" id='imagenSEO' className='data-test data-form' maxLength={255}/>
                                </div>
                                */}
                                <div className='row w-100 justify-content-end'>
                                <div className="col-md-12 p-2 text-center">
                                    <div>
                                        {/*!this.state.letter.seo.miniaturaImagenSEO
                                            ? (
                                                <div>
                                                    <p>No se ha seleccionado ninguna imagen.</p>
                                                </div>
                                            )
                                            : (
                                                <div>
                                                     
                                                        <img 
                                                            className="col-md-6"
                                                            src={(this.state.miniaturaImagenSEO.startsWith('http') || this.state.miniaturaImagenSEO.startsWith('data:image')) ? this.state.miniaturaImagenSEO :  (BASE_URL_PAIS + this.state.miniaturaImagenSEO)} 
                                                        />
                                                   
                                                    <br/>
                                                    <br/>  
                                                </div>
                                            )
                                        */}
                                    </div>
                                </div>
                                </div>
                                <div className="txtFile x-1">
                                    <input 
                                        name='glosarioEnlaceSEO'
                                        onChange={(e) => this.changeSeoValue(e)}
                                        type="text" 
                                        placeholder="Enlace" 
                                        id='enlaceSEO' 
                                        maxLength="255" 
                                        className="data-test data-form"
                                        value={this.state.letter.seo.glosarioEnlaceSEO}
                                    />
                                    <span id="longitudenlaceSEO"></span>
                                </div>
                                <div className="divWrapperActive">
                                    <div>
                                        <span>Motores de busqueda <br />seguir enlaces</span>
                                    </div>
                                    <div>
                                        <div 
                                            className={this.state.letter.seo.glosarioSeguirBuscadoresSEO ? "containerActive backgroundPosition" : "containerActive"} 
                                            //onClick={() => this.checkedValidate("seguirBuscadoresSEO")}
                                            onClick={() => this.changeSeoCheck('glosarioSeguirBuscadoresSEO', !this.state.letter.seo.glosarioSeguirBuscadoresSEO)}
                                        >
                                            <div 
                                                className={this.state.letter.seo.glosarioSeguirBuscadoresSEO 
                                                ? 
                                                "actionActive leftPosition" 
                                                : 
                                                "actionActive"
                                            }
                                            />
                                        </div>
                                        <span>{this.state.letter.seo.glosarioSeguirBuscadoresSEO ? "Activado" : "Desactivado"}</span>
                                    </div>
                                    <div>
                                        <span>Mostrar Pagina <br />Motores de Búsqueda </span>
                                    </div>
                                    <div>
                                        <div 
                                            className={this.state.letter.seo.glosarioMostrarBuscadoresSEO ? "containerActive backgroundPosition" : "containerActive"} 
                                            onClick={() => this.changeSeoCheck("glosarioMostrarBuscadoresSEO", !this.state.letter.seo.glosarioMostrarBuscadoresSEO)}
                                        >
                                            <div className={this.state.letter.seo.glosarioMostrarBuscadoresSEO ? "actionActive leftPosition" : "actionActive"}/>
                                        </div>
                                        <span>{this.state.letter.seo.glosarioMostrarBuscadoresSEO ? "Activado" : "Desactivado"}</span>
                                    </div>
                                </div>
                                <div className="txtFile x-1">
                                    <textarea 
                                        placeholder="Pegue aquí su código JavaScript" 
                                        onChange={(e) => this.changeSeoValue(e)}
                                        id="script" 
                                        style={{height:"100px"}} 
                                        maxLength="32000" 
                                        className="data-test data-form"
                                        name='glosarioScriptSEO'
                                        value={this.state.letter.seo.glosarioScriptSEO}
                                    />
                                    <span id="longitudscript"></span>
                                </div>
                            </div>
                        </div> 
                    </div>
                    }

                    {this.state.letraSeleccionada === '' ?
                        <div className="divContenedorBtn_Glosario">
                            <a href="" className="btnAddPalabraGlosario btnActivo" id="btnCreateGlosario" onClick={(e) => showCreateGlosario(e)}>AGREGAR </a>
                            <a href="" className="btnPrevAddPalabraGlosario" onClick={(event) => this.returnAdministradores(event)}>VOLVER</a>
                        </div>
                        :
                        <div className="divContenedorBtn_Glosario">
                            <a href="" className="btnActivo" onClick={(e) => this.updateSeoInLetter(e)}>GUARDAR</a>
                            <a href="" className="btnPrevAddPalabraGlosario" onClick={(event) => this.returnAdministradores(event)}>VOLVER</a>
                        </div>
                    }


                </div>

            </div>
        )
    }
}
